import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { IAISuggestion } from './aiSuggestions.props';

const selectAISuggestions = (state: RootState) => state.aiSuggestions;

const selectActiveSuggestions = createSelector(
  selectAISuggestions,
  (suggestions): IAISuggestion[] => Object.values(suggestions.byType)
);

const selectLastAgentCartRequestId = createSelector(
  selectAISuggestions,
  (suggestions) => suggestions.lastRequestId
);

export {
  selectAISuggestions,
  selectActiveSuggestions,
  selectLastAgentCartRequestId,
};
